import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const SuccessContainer = styled("div")(({ theme }) => ({
    display: "flex",
    width: "400px",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._600,
    alignSelf: "strech",

    "@media (max-width: 600px)": {
        width: "100%",
    },
}));

export const TitleContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._500,
    alignSelf: "strech",
}));

export const SuccessImage = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "strech",
    width: theme.space._1150,
    height: theme.space._1050,
}));

export const Title = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["3xl"],
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
}));

export const SubTitle = styled(Typography)(({ theme }) => ({
    color: theme.colors["neutral.50"],
    textAlign: "center",
    fontSize: theme.fontSizes["2xl"],
    fontFamily: theme.fonts.default,
    fontWeight: theme.fontWeights.bold,
    lineHeight: theme.lineHeights.slim,
}));

export const ContentContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech",
}));

export const CTAContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.space._400,
    alignSelf: "strech",
    marginTop: theme.space._400
}));
